module.exports = __webpack_public_path__ + "img/cd1.4c86de67.webp";